declare global {
  interface Window {
    ym?: (...args: any[]) => void;
    __METRIKA_COUNTER_ID__?: number;
  }
}

export function metrikaReachGoal(goal: string, params?: Record<string, any>) {
  if (process.env.NODE_ENV !== 'production') return;

  const id = window.__METRIKA_COUNTER_ID__;
  if (!id || typeof window.ym !== 'function') return;

  window.ym(id, 'reachGoal', goal, params);
}
